import { categories, hotRanking, timeline } from "@/mocks/melonData";

const accentCycle = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
  "bg-accent-100 text-accent-700",
  "bg-primary-100 text-primary-700",
  "bg-secondary-100 text-secondary-800",
];

export function TopicsSection() {
  return (
    <section id="topics" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-500">
          Channels
        </p>
        <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">
          六大热门栏目
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
          从影视到直播、从体坛到商界，每个栏目只收与其主题真正相关、且能交叉印证的实锤内容。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c, i) => (
          <a
            key={c.id}
            href="#list"
            className="group flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-100"
          >
            <div className="flex items-center justify-between">
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${accentCycle[i % accentCycle.length]}`}>
                <i className={c.icon}></i>
              </span>
              <span className="whitespace-nowrap rounded-full bg-background-100 px-2.5 py-1 text-[11px] font-medium text-foreground-500">
                {c.count}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg text-foreground-950">{c.name}</h3>
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-foreground-400">
              {c.en}
            </p>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 transition-colors group-hover:text-primary-700">
              进入实锤名单
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}

export function HotRankSection() {
  const medal = ["bg-primary-500", "bg-accent-500", "bg-secondary-600"];
  return (
    <section id="hot" className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
              Weekly Top
            </p>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              本周热榜
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              按讨论热度与印证完成度综合排序，前几位都是本周已基本收尾的落地瓜。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-600">
            <i className="ri-calendar-line"></i>
            统计区间：09.01 – 09.07
          </span>
        </div>

        <ol className="mt-8 space-y-2.5">
          {hotRanking.map((m, i) => {
            const rankColor = i < 3 ? medal[i] : "bg-background-300";
            const barWidth = 92 - i * 6;
            return (
              <li
                key={m.title}
                className="group relative grid grid-cols-[36px_1fr_auto] items-center gap-3 overflow-hidden rounded-lg border border-background-200 bg-background-50 px-4 py-3 transition-colors hover:border-primary-200 sm:gap-5"
              >
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-md font-heading text-sm text-background-50 ${rankColor}`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                    <h3 className="truncate text-sm font-semibold text-foreground-950 sm:text-base">
                      {m.title}
                    </h3>
                    <span className="hidden text-xs font-medium text-foreground-500 sm:inline">
                      {m.summary}
                    </span>
                  </div>
                  <div className="mt-1.5 h-1 w-full max-w-md overflow-hidden rounded-full bg-background-200">
                    <div
                      className={`h-1 rounded-full ${
                        i === 0
                          ? "bg-primary-500"
                          : i === 1
                            ? "bg-accent-500"
                            : i === 2
                              ? "bg-secondary-600"
                              : "bg-background-400"
                      }`}
                      style={{ width: `${barWidth}%` }}
                    ></div>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-1">
                  <span className="text-xs font-bold text-primary-600">{m.hot}</span>
                  <span className="whitespace-nowrap text-[11px] text-foreground-400">热度</span>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

export function TimelineSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-secondary-700">
          Resolved Timeline
        </p>
        <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
          落地瓜 · 盖棺定论
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
          近一周已走到收尾阶段的瓜，结论不再需要猜测。沿着时间轴，回看每一件如何从发酵到定论。
        </p>
      </div>

      <div className="relative mx-auto mt-12 max-w-2xl pl-1">
        <span className="absolute bottom-2 left-[15px] top-1 h-[calc(100%-8px)] w-px bg-background-200"></span>
        <div className="space-y-6">
          {timeline.map((t) => (
            <div key={t.date + t.title} className="relative flex gap-5 pl-12">
              <span className="absolute left-[10px] top-1.5 flex h-3 w-3 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500"></span>
              <div className="rounded-xl border border-background-200 bg-background-50 px-4 py-3.5 transition-colors hover:border-accent-200 md:px-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-800">
                    {t.tag}
                  </span>
                  <time className="text-xs font-medium text-foreground-500">2026.{t.date}</time>
                </div>
                <h3 className="mt-2 text-sm font-semibold text-foreground-950 md:text-base">
                  {t.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {t.note}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}